<dx-toolbar class="yo-toolbar">
  <dxi-item location="before">
    <div class="d-flex flex-row align-items-center">
      <div>
        <i class="fas fa-cubes mg-r-5 mg-l-15"></i> MATIÈRES PREMIÈRES
      </div>
    </div>
  </dxi-item>
  <dxi-item location="after">
    <div class="d-flex flex-row align-items-center">
      <yo-button
        iconClass="fas fa-trash"
        buttonClass="cta-inner-delete"
        [theme]="ButtonThemeEnum.DELETE_INNER"
        (onClick)="openDialogPerimes()">
      </yo-button>
    </div>
  </dxi-item>
</dx-toolbar>

<dx-data-grid
  [dataSource]="matieresPremieres | paginate: { itemsPerPage: pageSize, currentPage: page, totalItems: totalDenrees }"
  keyExpr="id"
  id="matiere-premiere-dx-grid"
  [allowColumnResizing]="true"
  [rowAlternationEnabled]="false"
  [showRowLines]="true"
  [showBorders]="true"
  (onRowPrepared)="onRowPrepared($event)"
  (onRowClick)="onRowSelect($event)"
  (onInitialized)="onInitialized()"
  #grid>
  <dxo-paging
    [enabled]="false">
  </dxo-paging>
  <dxo-pager
    [visible]="false">
  </dxo-pager>
  <dxi-column dataField="id" alignment="center" caption="Actions" [width]="80"
              [allowFiltering]="false"
              [allowGrouping]="false"
              cellTemplate="actionsCellTemplate">
  </dxi-column>
  <dxi-column dataField="produitDeclinaisonLibelle"
              alignment="left"
              caption="Matière Première"
              [allowGrouping]="false"
              [allowFiltering]="false">
  </dxi-column>
  <dxi-column dataField="produitDeclinaisonCode"
              alignment="left"
              caption="Code"
              [width]="200"
              [allowGrouping]="false"
              [allowFiltering]="false">
  </dxi-column>
  <dxi-column dataField="quantite"
              alignment="left"
              caption="Qté en Kilo"
              [allowGrouping]="false"
              [allowFiltering]="false"
              cellTemplate="qteCellTemplate">
  </dxi-column>
  <dxi-column dataField="pump"
              alignment="left"
              caption="P.U.M.P"
              [allowGrouping]="false"
              [allowFiltering]="false"
              cellTemplate="amountCellTemplate">
  </dxi-column>
  <dxi-column dataField="totalHT"
              alignment="left"
              caption="Total HT"
              [allowGrouping]="false"
              [allowFiltering]="false"
              cellTemplate="amountCellTemplate">
  </dxi-column>

  <div *dxTemplate="let cell of 'actionsCellTemplate'" class="custom-button-container">
    <yo-button iconClass="fas fa-plus"
               [theme]="cell.data.noStock ? this.selectedMatierePremiere == cell.data
                                          ? ButtonThemeEnum.WARNING_INNER : ButtonThemeEnum.WARNING
                                          : this.selectedMatierePremiere == cell.data ? ButtonThemeEnum.ADD_INNER : ButtonThemeEnum.ADD"
               tooltip="Ajout d'un nouveau lot" (onClick)="openDialogAjoutLot(cell.row.data, $event)"></yo-button>
  </div>
  <div *dxTemplate="let cell of 'qteCellTemplate'">
    {{ cell.value  | number:'1.4-4' }} Kg
  </div>
  <div *dxTemplate="let cell of 'amountCellTemplate'">
    {{ cell.value | number:'1.2-2' }} €
  </div>
</dx-data-grid>

<pagination-controls
  class="text-center"
  [directionLinks]="false"
  (pageChange)="handlePageChange($event)"
  responsive="true">
</pagination-controls>

<div [class]="stocksAnnounced ? 'container-lots' : ''">
  <yo-lots [stocks]="stocks" [matierePremiere]="selectedMatierePremiere" [filters]="filters"></yo-lots>
</div>

<yo-dialog-perimes
  [ngClass]="{'hidden-popup': !displayDialogPerimes}"></yo-dialog-perimes>
<yo-dialog-lot-ajout
  [ngClass]="{'hidden-popup': !displayDialogAjoutLot}"></yo-dialog-lot-ajout>
